import * as React from "react";
import * as S from "@styled";
import { useHistory, useParams } from "react-router-dom";
import { IAppReducerState } from "monitoringRules/shared/model";
import { AppContext } from "monitoringRules/App";
import { Permissions } from "../../shared/model/AllPermissions";
import { Utilities } from "../../shared/utilities";
import MonitoringRulesEnvironmentSelectMenu from "./EnvironmentSelectMenu";
import { RuleList } from "./RuleList";
import RuleContainer from "./RuleContainer";

const Layout: React.FC = () => {
    const { state, dispatch } = React.useContext<IAppReducerState>(AppContext);
    const { environmentName } = useParams<{ environmentName: string }>();
    const history = useHistory();

    const currentEnvironmentName = state.environments.find((env) => env?.name?.toLowerCase() === environmentName?.toLowerCase())?.name ?? "Unknown Environment";
    
    const getEnvironmentPath = (environmentName: string) => {
        return `${Utilities.getBaseUrlPath('MonitoringRules/List')}/${environmentName}`;
    }

    const handleEnvironmentChange = (environmentName: string) => {
        history.push(`/${environmentName}`);
    }

    const handleShowNewRuleEditor = () => {
        dispatch({ type: "SET_SHOW_NEW_RULE_EDITOR", showNewRuleEditor: true });
        dispatch({ type: "SET_SELECTED_RULE_ID", id: null });
    };

    const handleSaveRule = () => {
        dispatch({ type: "SET_SAVE_BUTTON_CLICKED", saveButtonClicked: true });
    }

    return (
        <S.IndentedContainer>
            <S.PageHeaderContainer>
                <h3>Administration /</h3>
                <h1>Monitoring Rules</h1>
            </S.PageHeaderContainer>
            <S.SidePanelLayout>
                <S.SidePanelFlexContainer>
                    <S.SidePanelContainer>
                        <S.InputGroup gap={8}>
                            {state.userPermissions[Permissions.MonitoringRulesEdit] &&
                                <S.Button disabled={state.showNewRuleEditor} id="createNewApi" onClick={handleShowNewRuleEditor}>
                                    <S.ButtonIcon className="ci-plus" />Add new Rule
                                </S.Button>}
                            <MonitoringRulesEnvironmentSelectMenu
                                currentEnvironmentName={currentEnvironmentName}
                                environments={state.environments}
                                onEnvironmentChange={handleEnvironmentChange}
                                getOptionLinkHref={getEnvironmentPath}
                            />
                        </S.InputGroup>
                        <RuleList />
                    </S.SidePanelContainer>
                    <S.ContentContainer>
                        <RuleContainer />
                    </S.ContentContainer>
                </S.SidePanelFlexContainer>
            </S.SidePanelLayout>
            <S.BottomBar isShown={state.isDirty}>
                <S.FlexContainer centerItems={true} gap={50}>
                    <h3>Unsaved changes</h3>
                    <S.Button
                        disabled={state.isLoading}
                        onClick={handleSaveRule}
                        variant={S.ButtonType.dark}
                        id="save-changes-button"
                    >
                        {FRENDS.Localizations.SaveChanges}
                    </S.Button>
                </S.FlexContainer>
            </S.BottomBar>
        </S.IndentedContainer>
    );
}

export default Layout;